/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_FibaInputs */

const th_event_fiba = /** @type {(inputs: Event_FibaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รับรองโดย FIBA`)
};

const en_event_fiba = /** @type {(inputs: Event_FibaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FIBA certified`)
};

const ja_event_fiba = /** @type {(inputs: Event_FibaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FIBA公認`)
};

const zh_event_fiba = /** @type {(inputs: Event_FibaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FIBA 认证`)
};

const es_event_fiba = /** @type {(inputs: Event_FibaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Certificado por la FIBA`)
};

const pt_event_fiba = /** @type {(inputs: Event_FibaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Certificado pela FIBA`)
};

const id_event_fiba = /** @type {(inputs: Event_FibaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bersertifikat FIBA`)
};

const fr_event_fiba = /** @type {(inputs: Event_FibaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Certifié FIBA`)
};

const tl_event_fiba = /** @type {(inputs: Event_FibaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sertipikado ng FIBA`)
};

const vi_event_fiba = /** @type {(inputs: Event_FibaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Được FIBA chứng nhận`)
};

const ko_event_fiba = /** @type {(inputs: Event_FibaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FIBA 인증`)
};

const de_event_fiba = /** @type {(inputs: Event_FibaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FIBA-zertifiziert`)
};

const ru_event_fiba = /** @type {(inputs: Event_FibaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сертифицировано FIBA`)
};

const tr_event_fiba = /** @type {(inputs: Event_FibaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FIBA onaylı`)
};

const it_event_fiba = /** @type {(inputs: Event_FibaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Certificato FIBA`)
};

const pl_event_fiba = /** @type {(inputs: Event_FibaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Certyfikat FIBA`)
};

const uk_event_fiba = /** @type {(inputs: Event_FibaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сертифіковано FIBA`)
};

const hi_event_fiba = /** @type {(inputs: Event_FibaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FIBA प्रमाणित`)
};

const ar_event_fiba = /** @type {(inputs: Event_FibaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`معتمدة من FIBA`)
};

const ms_event_fiba = /** @type {(inputs: Event_FibaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diperakui FIBA`)
};

const bn_event_fiba = /** @type {(inputs: Event_FibaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FIBA স্বীকৃত`)
};

const zh_tw2_event_fiba = /** @type {(inputs: Event_FibaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FIBA 認證`)
};

const zh_hk2_event_fiba = /** @type {(inputs: Event_FibaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FIBA 認證`)
};

const ur_event_fiba = /** @type {(inputs: Event_FibaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FIBA تصدیق شدہ`)
};

const fa_event_fiba = /** @type {(inputs: Event_FibaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`دارای گواهی FIBA`)
};

const sw_event_fiba = /** @type {(inputs: Event_FibaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Imeidhinishwa na FIBA`)
};

const nl_event_fiba = /** @type {(inputs: Event_FibaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FIBA-gecertificeerd`)
};

/**
* | output |
* | --- |
* | "FIBA certified" |
*
* @param {Event_FibaInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const event_fiba = /** @type {((inputs?: Event_FibaInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_FibaInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_event_fiba(inputs)
	if (locale === "ja") return ja_event_fiba(inputs)
	if (locale === "zh") return zh_event_fiba(inputs)
	if (locale === "es") return es_event_fiba(inputs)
	if (locale === "pt") return pt_event_fiba(inputs)
	if (locale === "id") return id_event_fiba(inputs)
	if (locale === "fr") return fr_event_fiba(inputs)
	if (locale === "tl") return tl_event_fiba(inputs)
	if (locale === "vi") return vi_event_fiba(inputs)
	if (locale === "ko") return ko_event_fiba(inputs)
	if (locale === "de") return de_event_fiba(inputs)
	if (locale === "ru") return ru_event_fiba(inputs)
	if (locale === "tr") return tr_event_fiba(inputs)
	if (locale === "it") return it_event_fiba(inputs)
	if (locale === "pl") return pl_event_fiba(inputs)
	if (locale === "uk") return uk_event_fiba(inputs)
	if (locale === "hi") return hi_event_fiba(inputs)
	if (locale === "ar") return ar_event_fiba(inputs)
	if (locale === "ms") return ms_event_fiba(inputs)
	if (locale === "bn") return bn_event_fiba(inputs)
	if (locale === "zh-TW") return zh_tw2_event_fiba(inputs)
	if (locale === "zh-HK") return zh_hk2_event_fiba(inputs)
	if (locale === "ur") return ur_event_fiba(inputs)
	if (locale === "fa") return fa_event_fiba(inputs)
	if (locale === "sw") return sw_event_fiba(inputs)
	if (locale === "nl") return nl_event_fiba(inputs)
	return en_event_fiba(inputs)
});